<template>
	<div class="field selection-block">
		<input
			type="checkbox"
			:name="name"
			:id="val"
			:value="val"
			v-model="checked"
			@change="onChange"
			ref="input"
		>
		<label
			:for="val"
			class="selection-block__label"
		>
			<span
				class="selection-label-image"
				:class="{ 'selection-label-image--placeholder' : !image }"
			>
				<img
					v-if="image"
					:src="image.url"
					:alt="image.description"
					class="selection-label-image__image"
				>
				<img
					v-else
					src="@/svg/selection-blob.svg"
					class="selection-label-image__placeholder"
				>
				<div class="selection-label-image__overlay"></div>
			</span>
			<span>{{ label }}</span>
		</label>
		<button
			class="btn--no-style selection-block__button"
			type="button"
			@click="showInformation"
		>
			<svg svg-inline="" focusable="false" role="presentation" width="3" height="14" viewBox="0 0 3 14" xmlns="http://www.w3.org/2000/svg"><rect y="3.75" width="2.25" height="9" rx="1.125"/><circle cx="1.125" cy="1.125" r="1.125"/></svg>
		</button>
	</div>
</template>

<script>
// Mixins
import { tagManager } from '@/mixins/tag-manager.js';

// Styles
import '@/sass/components/_selection-block.scss';

export default {
	mixins: [tagManager],
	props: ['name', 'val', 'label', 'image', 'info', 'value'],
	data() {
		return {
			checkedProxy: false
		};
	},
	computed: {
		checked: {
			get() {
				return this.value;
			},
			set(val) {
				this.checkedProxy = val;
			}
		}
	},
	methods: {
		onChange(e) {
			this.$emit('input', this.checkedProxy);

			if (this.$refs.input.checked === true) {
				this.pushToDataLayer('recipient-' + this.label.replace(/\s+/g, '-').toLowerCase() + '-selected');
			} else {
				this.pushToDataLayer('recipient-' + this.label.replace(/\s+/g, '-').toLowerCase() + '-deselected');
			}
		},
		showInformation() {
			this.$store.commit('popupOpen', true);
			this.$store.commit('popupContent', {
				heading: this.label,
				body: this.info
			});
		}
	}
};
</script>
